export default class TutorSettingAction {
  static TutorSettingStoreData(payload) {
    return {
      type: "TUTOR_SETTING_STORE_DATA",
      payload,
    };
  }

  static TutorSettingSubjectData(payload) {
    return {
      type: "TUTOR_SETTING_SUBJECT_DATA",
      payload,
    };
  }
}
